import { createAction, props } from '@ngrx/store';

export const setIsRead = createAction('[Funds] Set funds is read', props<{ fundId: string }>());
